/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Intro_H2Inputs */

const es_exp_mk_intro_h2 = /** @type {(inputs: Exp_Mk_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hace falta tener barco para hacerse a la mar.`)
};

const gl_exp_mk_intro_h2 = /** @type {(inputs: Exp_Mk_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai que ter barco para facerse á mar.`)
};

const en_exp_mk_intro_h2 = /** @type {(inputs: Exp_Mk_Intro_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not need a boat to get out on the water.`)
};

/**
* | output |
* | --- |
* | "You do not need a boat to get out on the water." |
*
* @param {Exp_Mk_Intro_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_intro_h2 = /** @type {((inputs?: Exp_Mk_Intro_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Intro_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_intro_h2(inputs)
	if (locale === "en") return en_exp_mk_intro_h2(inputs)
	return es_exp_mk_intro_h2(inputs)
});